import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

// 1. The Individual Card Skeleton
export const AttractionCardSkeleton = () => {
  return (
    <SkeletonTheme baseColor="#ebebeb" highlightColor="#f5f5f5">
      <div className="attraction-card" style={{ 
        padding: '0', 
        borderRadius: '12px', 
        overflow: 'hidden', 
        backgroundColor: '#fff', 
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        height: '100%' 
      }}>
        {/* Mimics the rounded Image box at the top */}
        <Skeleton height={180} borderRadius="12px 12px 0 0" />

        <div style={{ padding: '15px' }}>
          {/* Mimics the Title */}
          <Skeleton width="70%" height={24} style={{ marginBottom: '10px' }} />

          {/* Mimics the Price line ($ and Clock icon) */}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
            <Skeleton width="10%" height={16} />
            <Skeleton circle width={16} height={16} />
          </div>

          {/* Mimics the two bottom buttons */}
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <Skeleton width={100} height={20} />
            <Skeleton width={140} height={35} borderRadius="8px" />
          </div>
        </div>
      </div>
    </SkeletonTheme>
  );
};

export const gridStyles = {
    display: 'grid',
    gap: '24px',
    marginTop: '20px',
    width: '100%',
    // This line creates exactly 3 columns on desktop, 
    // but automatically drops to 2 or 1 as the screen shrinks.
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))'
  };